import Neo from "../components/Neo";

const NeoPage = () => {
  return (
    <div className="container mx-auto">
      <Neo />
    </div>
  );
};

export default NeoPage;
